import React from 'react';

import Collapsible from '../../../../library/collapsible/collapsible';
import Typography from '../../../../library/typography/typography';
import AddProductButton from '../../../../components/add-product-button/add-product-button';
import PhoneNumber from '../../../../components/phone-number/phone-number';
import Price from '../../../../components/price/price';
import ProductQuantity from '../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../components/quantity-disclaimer/quantity-disclaimer';
import StickyFooter from '../../../appointment-page/components/sticky-footer/sticky-footer';
import PhoneSolidIcon from '../../../../shared/icons/phone-solid-icon';

import {
  useProductEntryDataLayerValues,
  useScrollDirection
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { getPriceInfo } from '../../../../shared/utils/product/product';

import { Fitment } from '../../../../shared/types/fitment';
import { ProductItem } from '../../../../shared/types/product';

import './sticky-add-to-cart-section.scss';

interface StickyAddToCartSectionProps {
  className?: string;
  defaultQuantity: number;
  isCanonicalProduct?: boolean;
  isDisabled?: boolean;
  isSet?: boolean;
  isStaggered: boolean;
  price: number;
  productItem: ProductItem;
  productType: string;
  selectedFitment?: Fitment;
  storeCode?: string | null;
  totalQuantity?: number;
  updateQuantity: (e: Event, quantity: number) => void;
}

function StickyAddToCartSection(props: StickyAddToCartSectionProps) {
  const {
    className = '',
    defaultQuantity,
    isCanonicalProduct = false,
    isDisabled = false,
    isSet,
    isStaggered,
    price,
    productItem,
    productType,
    selectedFitment,
    storeCode,
    totalQuantity,
    updateQuantity
  } = props;

  const { prebuiltPackage, product, quantity, rearQuantity } = productItem;
  const { mapDisplayRule, mapPrice, mapRuleSatisfied, priceRange, unitName } =
    product || {};

  const priceInfo = getPriceInfo(product);
  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();
  const { isScrollingDown } = useScrollDirection();

  return (
    <StickyFooter className={className} styleName="container">
      <div styleName="quantity-and-price">
        {!isStaggered && !isSet && (
          <>
            <Price
              instantPromotionOriginalRetailValue={
                priceInfo?.instantPromotionOriginalRetailValue
              }
              mapPrice={{
                mapPriceDisplay: mapDisplayRule?.mapPriceDisplay,
                mapRuleSatisfied,
                price: mapPrice?.value
              }}
              price={price}
              priceRange={priceRange}
              totalQuantity={totalQuantity}
              unitName={unitName}
              variant="H3"
            />

            {(selectedFitment && isCanonicalProduct && !priceRange) ||
            !isCanonicalProduct ? (
              <ProductQuantity
                aria-label="quantity-input"
                defaultValue={defaultQuantity}
                id="quantity"
                isHorizontal
                onBlur={updateQuantity}
                onChange={updateQuantity}
                showLabel
                value={quantity}
              />
            ) : null}
          </>
        )}
      </div>

      <AddProductButton
        isDisabled={isDisabled}
        onClick={() =>
          trackAction(
            'product_detail_cart_add',
            getProductEntryDataLayerValues(product, quantity, rearQuantity)
          )
        }
        productItem={productItem}
        storeCode={storeCode}
      />

      {!prebuiltPackage && (
        <QuantityDisclaimer
          productType={productType}
          quantity={quantity}
          styleName="quantity-disclaimer"
        />
      )}

      <Collapsible
        label={
          <div styleName="toggle">
            <Typography>{`Need help? Call us at: `}</Typography>
            &nbsp;&nbsp;
            <PhoneSolidIcon />
            &nbsp;&nbsp;
            <PhoneNumber
              phone={window.isDT ? '888-796-1728' : '888-443-3503'}
            />
            &nbsp;&nbsp;
          </div>
        }
        styleName={`need-help ${isScrollingDown ? 'need-help--hidden' : ''} `}
        toggleType="CHEVRON"
      >
        <Typography styleName="hours">
          M-F: 8AM - 8PM ET &nbsp;&nbsp; Sat: 8AM - 7PM ET
        </Typography>
      </Collapsible>
    </StickyFooter>
  );
}

export default StickyAddToCartSection;
